export default {
    'button.cancel': '取消',
    'button.save': '保存',
    'error.internal': '服务器内部错误，请重试。',
    'label.UID': 'SAP Number',
    'label.add': '添加',
    'label.addDict': '字典表',
    'label.address': '地址',
    'label.agentEmployeeId': '代理人工号',
    'label.authorizer': '授权人工号',
    'label.authorizerName': '授权人姓名',
    'label.cancel': '取消',
    'label.code': '编码',
    'label.content': '内容',
    'label.createTime': '创建时间',
    'label.dataPermissions': '数据权限',
    'label.delegation': '授权',
    'label.delegationName': '代理人姓名',
    'label.delete': '删除',
    'label.detail': '详情',
    'label.edit': '编辑',
    'label.endDate': '结束日期',
    'label.endTime': '结束时间',
    'label.item': '条目',
    'label.no': '否',
    'label.notification.content': '内容',
    'label.notification.content.placeholder': '搜索内容...',
    'label.notification.handle': '处理',
    'label.notification.ignore': '已读',
    'label.notification.read': '已读',
    'label.notification.setRead': '设置为已读',
    'label.notification.title': '标题',
    'label.notification.title.placeholder': '搜索标题...',
    'label.notification.unread': '未读',
    'label.operation': '操作',
    'label.permission.action': '权限动作',
    'label.permission.code': '权限编码',
    'label.permission.description': '权限描述',
    'label.permission.name': '权限名称',
    'label.permission.type': '权限类型',
    'label.permissions': '权限列表',

    'label.remark': '备注',
    'label.reset': '重置',
    'label.role.code': '角色编码',
    'label.role.description': '角色描述',
    'label.role.isGlobal': '全局角色',
    'label.role.name': '角色名称',
    'label.roles': '角色列表',
    'label.save': '保存',
    'label.search': '搜索',
    'label.space': '',
    'label.startDate': '开始日期',
    'label.Date': '日期',
    'label.startTime': '开始时间',
    'label.status': '状态',
    'label.submit': '提交',
    'label.synchronize': '同步',
    'label.total': '共计',
    'label.type': '类型',
    'label.user.approval-status': '审批状态',
    'label.user.type': '用户类型',
    'label.username': '用户名',
    'label.yes': '是',
    'menu.application-management': '应用管理',
    'menu.audit': '审计日志',
    'menu.delegation': '代理授权',
    'menu.dictionary': '数据字典',
    'menu.domain': 'Domain',
    'menu.home': '首页',
    'menu.homepage': '首页',
    'menu.notFound': '菜单不存在',
    'menu.rbac': 'RBAC 管理',
    'menu.rbac.permission': '权限管理',
    'menu.rbac.permission.data': '数据权限',
    'menu.rbac.permission.home': '通用权限',
    'menu.rbac.role': '角色管理',
    'menu.rbac.user': '用户管理',
    'menu.rbac.user-approval': '用户审批',
    'menu.system': '系统管理',
    'menu.system.dictionary': '数据字典',
    'menu.system.test': '展示',
    'menu.system.notification': '通知管理',
    'menu.searchTitle':'查询条件',
    'menu.searchPickUpLocationTitle':'Pick-up Location Maintenance',
    'menu.support.pickUpDate':'Pick-up Dates Maintenance',
    'menu.support.congratulationTemplate':'Help Center',
    'menu.support.NDelegation': 'Nomination Delegation',
    'menu.support.budget':'Budget Maintenance',
    'menu.support.demo':'Demo',
    'menu.support.cancellation':'Cancellation',
    'message.cancel.success': 'Cancel record success.',
    'menu.menuTitle':'结果展示',
    'menu.Resource': '资源',
    'menu.Sourcing': '采购',
    'menu.support.maintenance':'HRBP Maintenance',
    'message.backHome': '返回首页',
    'message.delete.confirm': '确认要删除该记录吗？',
    'message.delete.success': '删除记录成功。',
    'message.edit.sucess': '编辑成功',
    'message.inputSearch': '请输入关键字点击查询',
    'message.noFavours': '收藏暂无',
    'message.noNotify': '通知暂无',
    'message.notfound': '对不起，你访问的页面不存在',
    'message.notification.setRead': '确认要设置为已读吗？',
    'message.permission.async': '确认要同步权限吗？',
    'message.permission.delete': '确认要删除该权限吗？',
    'message.role.delete': '确认要删除该角色吗？',
    'message.save.success': '已保存',
    'message.set.success': '设置成功',
    'message.user.delete': '确认要删除该用户吗?',
    'notifier.clear': '清空通知',
    'notifier.more': '查看更多',
    'rbac.role.title': '角色',
    'rbac.user.title': '用户',
    'rule.empty': '当前信息不能为空',
    'rule.endTime': '结束日期不能为空',
    'rule.format': '当前信息格式不正确。',
    'rule.startTime': '开始日期不能为空',
    'rule.targetUserId': '代理人工号不能为空',
    'label.table.edit':'编辑',
    'label.table.delete':'删除',

    // 测试页
    'menu.demo':'示例',
    'menu.demoTest':'示例页面',
    'menu.approve':'Approval & Report',
    'menu.approve.report':'Application Report',
    'menu.bestyou':'Best YOU',
    'menu.nomination':'Nomination',
    'menu.nomination.eyes':'Best in My Eyes',
    'menu.about':'About Best YOU',
    'menu.support':'Support Tool',
    'menu.support.pickUpLocation':'Pick-up Location Maintenance',
    'menu.nomination.history':'Nomination History',
    'menu.searchHistoryTitle':'Nomination Check',
    'label.eyes.type':'Type',
    'label.eyes.nominee':'Nominee',
    'label.eyes.nomineeManger':'Nominee Manager',
    'label.eyes.criteria':'Criteria',
    'label.eyes.nominationExplanation':'Nomination Story',
    'label.eyes.nominatorName':'Nominator Name',
    'label.eyes.Behalf':'On behalf of',
    'label.eyes.NominatorDepartment':'Nominator Department',
    'label.eyes.name':'Name',
    'label.eyes.email':'Email',
    'label.eyes.staffID':'Staff ID',
    'label.eyes.managerName':'Manager Name',
    'label.eyes.managerEmail':'Manager Email',
    'label.eyes.managerDept':'Nominee Department',
    'label.close':'Close',
    'label.ok': 'OK',
    'label.userSelect':'User Selector',
    'label.name':'Name',
    'label.phone':'Phone',
    'label.email':'Email',
    'label.dept':'Department',
    'label.queryResult':'Query Result',
    'label.quicklinks':'Quick Links',
    'label.area': 'Area',
    'label.city':'City',
    'label.areaCN':'Area(CN)',
    'label.areaEN':'Area(EN)',
    'label.addressCN':'Address(CN)',
    'label.addressEN':'Address(EN)',
    'message.location.delete':'Are you sure to delete this location?',
    'label.shortName':'Short Name',

    'label.entity':'Entity'
};
